import type { Assignee } from '@fitting-room/contracts'

/**
 * Who an appointment is put against. A native `<select>`, as tperent's
 * `AssigneeSelect` is: a short list, keyboard and the phone's own wheel for
 * free.
 *
 * Lists the active team. An appointment still held by someone since
 * deactivated keeps them as an option — by name, marked inactive — so the
 * control shows the truth and re-saving the form does not quietly unassign
 * it. Only an id nobody on the team has is "a former team member".
 */
export function AssigneeSelect({
  members,
  value,
  onChange,
  disabled,
  label = 'Bridal stylist',
}: {
  readonly members: readonly Assignee[]
  readonly value: string | null
  readonly onChange: (next: string | null) => void
  readonly disabled?: boolean
  readonly label?: string
}) {
  const active = members.filter((member) => member.active)
  const held = value === null ? undefined : members.find((member) => member.id === value)
  return (
    <select
      className="st-select w-full"
      aria-label={label}
      value={value ?? ''}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value === '' ? null : event.target.value)}
    >
      <option value="">Unassigned</option>
      {active.map((member) => (
        <option key={member.id} value={member.id}>
          {member.calendarMark ? `${member.calendarMark} ` : ''}
          {member.displayName}
        </option>
      ))}
      {value === null || held?.active ? null : (
        <option value={value}>{held ? `${held.displayName} (inactive)` : 'A former team member'}</option>
      )}
    </select>
  )
}
